<script>
import bem from '@/utils/bem';

const b = bem('button-default');

export default {
  props: {
    click: {
      type: Function,
      required: true,
    },
    className: {
      type: String,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#eec586',
    },
    textColor: {
      type: String,
      required: false,
      default: '#293241',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
    children: {
      type: [String, Node],
      required: false,
      default: undefined,
    },
  },
  methods: {
    b,
  },
};
</script>

<template>
  <button
    v-if="children"
    :class="b('', { isMobile, mix: className })"
    :style="{
      backgroundColor: backgroundColor,
      color: textColor,
    }"
    type="button"
    :disabled="disabled"
    @click="click"
  >
    {{ children }}
  </button>
</template>

<style scoped lang="scss">
@import 'src/styles/media.scss';
@import 'src/styles/fonts.scss';

.button-default {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  outline: none;
  border: none;
  box-shadow: 3.8px 5.9px 9.9px 3.1px rgba(95, 138, 164, 0.42);
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  width: 383px;
  height: 70px;

  @include mediaMinMax(1025, $normal) {
    width: vw-full(383);
    height: vw-full(70);
    font-size: vw-full(22);
  }
  &_isMobile {
    width: 279px;
    height: 47px;
    font-size: 15px;
  }
}
</style>
